import { api } from "@/lib/api";
import { documentSchemas } from "@/config/documentSchemas";

const SKIP = new Set(["note"]);
const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export async function descargarMapaCampos() {
  const { data } = await api.get("/copiloto/why");
  const idx = {};
  data.forEach((e) => (e.fields || []).forEach((f) => {
    const k = `${e.document}::${f}`;
    idx[k] = [...(idx[k] || []), `${e.jurisdiccion}: ${e.estado}`];
  }));
  const rows = [["document", "field", "pregunta", "seccion", "tiene_explicacion", "estado"]];
  Object.entries(documentSchemas).forEach(([doc, sch]) => {
    sch.steps.forEach((st) => st.fields.forEach((f) => {
      if (SKIP.has(f.type) || !f.name) return;
      const e = idx[`${doc}::${f.name}`];
      rows.push([doc, f.name, f.label || "", st.title, e ? "sí" : "no", e ? e.join(" | ") : ""]);
    }));
  });
  const csv = "\ufeff" + rows.map((r) => r.map(esc).join(",")).join("\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url; a.download = "mapa_campos_copiloto.csv"; a.click();
  URL.revokeObjectURL(url);
}
